import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../components/ui/Button';
export function Stub() {
  const location = useLocation();
  const pathName = location.pathname.replace('/', '').replace(/-/g, ' ');
  const title = pathName ? pathName.charAt(0).toUpperCase() + pathName.slice(1) : 'Page';
  return <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-20 bg-brand-light" data-id="element-968" data-mp="597b49ma8spv">
      <div className="max-w-2xl mx-auto" data-id="element-969" data-mp="3dmen6xp0s4sx">
        <span className="inline-block py-1 px-3 rounded-full bg-brand-red/10 text-brand-red text-sm font-semibold tracking-wider mb-6" data-id="element-970" data-mp="39nfine77aa20">
          COMING SOON
        </span>
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-6 capitalize" data-id="element-971" data-mp="3inkgoxqi7w3i">
          {title}
        </h1>
        <p className="text-lg text-slate-600 mb-10 leading-relaxed" data-id="element-972" data-mp="2ux80z0p0ov2d">
          We are currently building this section to provide you with
          comprehensive information about our {title.toLowerCase()}. Please
          check back soon.
        </p>
        <div className="flex flex-wrap justify-center gap-4" data-id="element-973" data-mp="zpyteqvb0cxd">
          <Button href="/" variant="outline" data-id="element-974" data-mp="14puyyujngcf1">
            Return Home
          </Button>
          <Button href="/book" variant="primary" data-id="element-975" data-mp="19ixisaymk7i1">
            Book Appointment
          </Button>
        </div>
      </div>
    </div>;
}